class ShippingAddress {
  constructor(id, street, city, zipcode, country) {
    this._id = id;
    this._street = street;
    this._city = city;
    this._zipcode = zipcode;
    this._country = country;
  }

  isValid() {
    for (var item in this) {
      if (this[item] === null || this[item] === '' || this[item] === undefined) {
        return false;
      }
    }
    return true;
  }

  // getters
  getId() {
    return this._id;
  }

  getStreet() {
    return this._street;
  }

  getCity() {
    return this._city;
  }

  getZipcode() {
    return this._zipcode;
  }

  getCountry() {
    return this._country;
  }

  // setters
  setId(newId) {
    this._id = newId;
    return this;
  }

  setStreet(newStreet) {
    this._street = newStreet;
    return this;
  }

  setCity(newCity) {
    this._city = newCity;
    return this;
  }

  setZipcode(newZipcode) {
    this._zipcode = newZipcode;
    return this;
  }

  setCountry(newCountry) {
    this._country = newCountry;
    return this;
  }

  serialize() {
    return { ...this, '@type': 'ShippingAddress' };
  }

  clone() {
    return new ShippingAddress(this._id, this._street, this._city, this._zipcode, this._country);
  }

  static deserialize(raw) {
    return new ShippingAddress(raw._id, raw._street, raw._city, raw._zipcode, raw._country);
  }
}

export default ShippingAddress;



// WEBPACK FOOTER //
// ./src/models/SFModels/ShippingAddress.js